import { Snackbar, SnackbarCloseReason, SnackbarContent } from "@mui/material";
import { styled } from "@mui/system";
import { COLORS } from "../../constants";

const StyledSnackbarContent = styled(SnackbarContent)<{ custombackgroundcolor?: string }>(
  ({ custombackgroundcolor }) => ({
    backgroundColor: custombackgroundcolor,
    fontSize: "1.2rem",
    minWidth: "unset",
    color: "#fff",
  })
);

export default function CustomSnackbar({
  open,
  message,
  autoHideDuration,
  color = COLORS.DIDACTO_DARK_GREY,
  onClose,
}: {
  open: boolean;
  message: string;
  autoHideDuration: number | null;
  color?: string;
  onClose: (event: React.SyntheticEvent | Event, reason?: SnackbarCloseReason) => void;
}) {
  return (
    <Snackbar open={open} autoHideDuration={autoHideDuration} onClose={onClose}>
      <StyledSnackbarContent message={message} custombackgroundcolor={color} />
    </Snackbar>
  );
}
